// extracted by mini-css-extract-plugin
module.exports = {"camsAndForecasts":"CamsAndForecasts_camsAndForecasts__trwW2"};